import { createContext } from 'react';
import type { RootStore } from '@uplift/store';

export const RootStoreContext = createContext<RootStore>(null);
